import cn from 'classnames';
import type React from 'react';
import Modal from 'react-modal';
import { Close } from '@shared/assets';
import * as st from './ModalLarge.module.scss';

export interface ModalProps {
  isOpen: boolean;
  children?: React.ReactNode;
  close?: () => void;
  onRequestClose?: () => void;
  info?: string;
  title?: string;
  disableHeader?: boolean;
  className?: string;
}

Modal.setAppElement('#root');

const ModalLarge = ({
  isOpen,
  children,
  close,
  onRequestClose,
  info,
  title,
  disableHeader,
  className,
}: ModalProps): JSX.Element => {
  const onAfterOpen = () => {
    document.body.style.overflow = 'hidden';
  };

  const onAfterClose = () => {
    document.body.style.overflow = 'auto';
  };

  return (
    <Modal
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      className={cn(st.modal, className)}
      overlayClassName={st.overlay}
    >
      {!disableHeader && (
        <section className={st.head}>
          <span className={st.head__info}>{info}</span>
          <h2 className={st.head__title}>{title}</h2>
          <div className={cn(st.head__close, onRequestClose && st.hidden)} onClick={close}>
            <Close />
          </div>
        </section>
      )}

      {children}
    </Modal>
  );
};

export default ModalLarge;
